// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_29URz","liveblog":"Mf7gK","figure-caption":"_1x_Ts","image-attribute":"SUbRl","image-caption":"rvehX"};